import Link from "next/link";

import styled from "styled-components";

import { motion } from "@enkor/framer-motion";

import { getOpacityColor, grayScale } from "@enkor/design/colors";
import { Z_INDEX } from "@enkor/design/variables";
import { APP_SIZE, HEADER_SIZE } from "@styles/variables";

export const Header = styled.header`
  position: fixed;
  top: 0;
  left: 50%;
  z-index: ${Z_INDEX.NAVBAR};

  width: 100%;
  max-width: ${APP_SIZE.MAX_WIDTH}px;

  background-color: transparent;

  transform: translateX(-50%);
`;

export const Navbar = styled.nav<{
  $shouldShowBackground?: boolean;
  $shouldFixSafeArea?: boolean;
}>`
  display: flex;
  justify-content: space-between;
  align-items: center;

  height: ${({ $shouldFixSafeArea }) =>
    $shouldFixSafeArea
      ? `calc(36px + ${HEADER_SIZE.HEIGHT}px)`
      : `calc(env(safe-area-inset-top) + ${HEADER_SIZE.HEIGHT}px)`};

  padding: 0 16px;

  padding-top: ${({ $shouldFixSafeArea }) =>
    $shouldFixSafeArea ? "36px" : "env(safe-area-inset-bottom)"};

  background-color: ${({ $shouldShowBackground }) =>
    $shouldShowBackground
      ? getOpacityColor(grayScale[200], 0.7)
      : "transparent"};

  transition: all 0.3s ease-in-out;

  background-color: ${({ $shouldShowBackground }) =>
    $shouldShowBackground
      ? getOpacityColor(grayScale[200], 0.7)
      : "transparent"};

  transition: all 0.3s ease-in-out;

  -webkit-backdrop-filter: ${({ $shouldShowBackground }) =>
    $shouldShowBackground ? "blur(4px)" : "unset"};
  backdrop-filter: ${({ $shouldShowBackground }) =>
    $shouldShowBackground ? "blur(4px)" : "unset"};

  h1 {
    position: absolute;
    top: 50%;
    left: 50%;

    color: ${grayScale.white};

    transform: translate(-50%, -50%);
  }

  button {
    background-color: ${({ $shouldShowBackground }) =>
      $shouldShowBackground ? "transparent" : grayScale[200]};
  }
`;

export const LeftButton = styled(motion.button)`
  width: 32px;
  height: 32px;
  padding: 4px;
  border-radius: 50%;
`;

export const RightButtonGroup = styled.div`
  position: relative;
  display: flex;
`;

export const NavRightButton = styled(motion.button)`
  width: 32px;
  height: 32px;
  padding: 4px;
  border-radius: 50%;
`;

export const AppLink = styled(motion(Link))`
  padding: 4px 8px;
  border-radius: 9999px;

  color: ${grayScale.white};
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
`;
